<div class="bg_calculator">
  <app-headercontent></app-headercontent>
  <div class="container mb-3" *ngIf="budget != null">
    <a class="back__link" [routerLink]="['/budget-preview/'+budget.IdBudget]">Operaciones de Mantenimiento</a>
  </div>
</div>
<div class="bg_selected_car pt-3 pb-7">
  <div *ngIf="showForm && loaded" class="cont__form">
    <div class="container">
      <div class="row mb-2">
        <div class="col-md-12">
          <strong>Tu CUPRA:</strong>
        </div>
      </div>
      <form [formGroup]="dataform" (ngSubmit)="saveCupraCare()">
        <div *ngIf="budget" class="row">
          <div class="col-md-6">
            <img [src]="pathServer + budget.ModelVersion.ModelImage" alt="Tu CUPRA" class="img-fluid">
          </div>
          <div class="col-md-6 my__cupra">
            <div class="model">{{budget.ModelVersion.Model}}</div>
            <div class="motor">{{budget.ModelVersion.MotorType}}</div>
            <div class="version">{{budget.ModelVersion.Version}}</div>
            <div class="version">{{budget.Distributor}}</div>
          </div>
        </div>
        <div class="row mt-3 mb-2">
          <div class="col-12">
            <hr />
            <h3>Contratar CUPRA Care</h3>
          </div>
        </div>
        <div>
          <div class="row">
            <div class="col-md-6 mb-3">
              <div class="form-floating">
                <input type="text" id="Ccname" formControlName="CcName" class="form-control floatLabel" [ngClass]="{ 'is-invalid': submitted && f.CcName.errors,'is-valid': !f.CcName.errors  }" class="form-control" placeholder="Nombre" />
                <label for="CcName">Nombre</label>
                <div *ngIf="submitted && f.CcName.errors" class="invalid-feedback">
                  <div *ngIf="f.CcName.errors.required">Nombre requerido</div>
                  <div *ngIf="f.CcName.errors.maxlength">Nombre demasiado largo</div>
                </div>
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <div class="form-floating">
                <input type="text" id="CcSurname" formControlName="CcSurname" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.CcSurname.errors,'is-valid': !f.CcSurname.errors  }" class="form-control" placeholder="Apellidos" />
                <label for="CcSurnamee">Apellidos</label>
                <div *ngIf="submitted && f.CcSurname.errors" class="invalid-feedback">
                  <div *ngIf="f.CcSurname.errors.required">Apellidos requeridos</div>
                  <div *ngIf="f.CcSurname.errors.maxlength">Apellidos demasiados largos</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-md-6 mb-3">
              <div class="form-floating">
                <input type="text" id="mail" formControlName="CcEmail" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.CcEmail.errors, 'is-valid': !f.CcEmail.errors }" placeholder="Correo electrónico" />
                <label for="CcEmail">Email</label>
                <div *ngIf="submitted && f.CcEmail.errors" class="invalid-feedback">
                  <div *ngIf="f.CcEmail.errors.required">Correo electrónico requerido</div>
                  <div *ngIf="f.CcEmail.errors.pattern">Formato Incorrecto</div>
                  <div *ngIf="f.CcEmail.errors.maxlength">Correo electrónico demasiado largo</div>
                </div>
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <div class="form-floating">
                <input type="number" id="phone" formControlName="CcPhone" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.CcPhone.errors, 'is-valid': !f.CcPhone.errors }" placeholder="Teléfono" />
                <label for="CcPhone">Teléfono</label>
                <div *ngIf="submitted && f.CcPhone.errors" class="invalid-feedback">
                  <div *ngIf="f.CcPhone.errors.required">Teléfono requerido</div>
                  <div *ngIf="f.CcPhone.errors.pattern">Formato Incorrecto</div>
                  <div *ngIf="f.CcPhone.errors.max">Formato Incorrecto</div>
                  <div *ngIf="f.CcPhone.errors.min">Formato Incorrecto</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-md-6 mb-3">
              <div class="form-floating">
                <input type="text" id="Matricula" formControlName="Matricula" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.Matricula.errors, 'is-valid': submitted && !f.Matricula.errors }" class="form-control
                           " placeholder="Matrícula" />
                <label for="Matricula">Matrícula</label>
                <div *ngIf="submitted && f.Matricula.errors" class="invalid-feedback">
                  <div *ngIf="f.Matricula.errors.required">Matrícula requerida</div>
                  <div *ngIf="f.Matricula.errors.maxlength">Matrícula demasiado larga</div>
                </div>
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <div class="form-floating">
                <input type="text" id="Bastidor" formControlName="Bastidor" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.Bastidor.errors, 'is-valid': submitted && !f.Bastidor.errors }" class="form-control
                           " placeholder="Bastidor" />
                <label for="Bastidor">Bastidor</label>
                <div *ngIf="submitted && f.Bastidor.errors" class="invalid-feedback">
                  <div *ngIf="f.Bastidor.errors.required">Bastidor requerido</div>
                  <div *ngIf="f.Bastidor.errors.maxlength">Bastidor demasiado largo</div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="submitted && f.CcIdDistributor.errors">
            <div *ngIf="f.CcIdDistributor.errors.required">
              <h3>Distribuidor requerido</h3>
            </div>
          </div>
          <div class="row select__distributor">
            <div class="col-md-6 mb-3" (click)="selectDistri(elem.IdDistributor)" *ngFor="let elem of distrisList" id="distri{{elem.IdDistributor}}">
              <div class="card distributor-select">
                <div class="card-header">
                  {{elem.Distributor}}
                </div>
                <div class="card-body">
                  <ul>
                    <li>{{elem.Address}}</li>
                    <li>{{elem.Cp}} <span class="sep">|</span> {{elem.City}}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-3 mt-md-5">
          <div class="col2 text-center"><button type="submit" class="btn btn-primary mb-3 mr-2">Solicitar contratación</button></div>
        </div>
      </form>
    </div>
  </div>
</div>
<div *ngIf="!showForm && loaded">
  <div class="container">
    <div class="row mt-3 mt-md-5 mb-3">
      <div class="col-md-12">
        Gracias por tu solicitud de contratación de CUPRA CARE. En breve tu Servicio Especialista CUPRA se pondrá en contacto contigo.
      </div>
    </div>
  </div>
</div>